import React from 'react';
import PropTypes from 'prop-types';

import { format } from 'inside-out/managers/dateManager';
import { Link } from 'inside-out/components/shared/link';

import PDFIcon from 'inside-out/images/pdf-icon.svg';
import { wrapperStyle, wrapperLinkStyle, titleStyle, metaDateStyle } from './styles';

class PolicyCardComponent extends React.PureComponent {
	render() {
		const { id, to, href, title, date } = this.props;

		return (
			<Link className={wrapperLinkStyle} to={to} href={href} data-component="Card">
				<article className={wrapperStyle} id={`item-${id}`}>
					<img src={PDFIcon} alt="" />
					<h1 className={titleStyle}>{title}</h1>
					{date && <p className={metaDateStyle}>{format(date)}</p>}
				</article>
			</Link>
		);
	}
}

PolicyCardComponent.propTypes = {
	id: PropTypes.string,
	to: PropTypes.string,
	href: PropTypes.string,
	title: PropTypes.string,
	date: PropTypes.string,
};

export const PolicyCard = PolicyCardComponent;



// WEBPACK FOOTER //
// ./src/components/shared/cards/policyCard/component.js